{
  "pt": {
    "upsell": {
      "categories": {
        "category": "Categoria",
        "home_automation": "Domótica",
        "integration": "Integração",
        "interior_decoration": "Decoração de interiores",
        "interior_doors": "Portas interiores",
        "kitchen": "Cozinha",
        "marketing": "Marketing",
        "real_estate_agent": "Agente imobiliário",
        "telecom": "Telecomunicações",
        "wood_finishing": "Acabamento da madeira"
      },
      "contact_us": "Interessado? Contacte-nos!",
      "decisions_partners": {
        "guidance": "Os parceiros de decisão podem criar e/ou gerir propostas se tiverem permissão.",
        "intercom": "Olá Ziggu! Estou interessado na funcionalidade Parceiros de decisão. Pode fornecer-me mais informações? Com os melhores cumprimentos, %{name}"
      },
      "decisions_proposals_multiple_approval": {
        "cta": "Fale connosco para saber mais",
        "description": "Cansado de cancelar a aprovação de uma proposta para acrescentar algumas alterações e começar tudo de novo? A necessidade de várias aprovações não o deve atrasar.",
        "description_2": "Permita que os seus clientes aprovem várias propostas na mesma decisão. Não é necessário anular a aprovação de uma proposta existente ou iniciar uma nova decisão.",
        "description_3": "Menos complicações e mais tempo para se concentrar no que realmente importa: o seu cliente!",
        "intercom": "Olá Ziggu! Pretendo que o cliente possa aprovar várias propostas numa decisão. Pode fornecer mais informações? Com os melhores cumprimentos, %{name}",
        "premium_add_on": "Suplemento Premium",
        "title": "Poupe tempo com a extensão de propostas flexíveis!"
      },
      "decisions_reminders": {
        "guidance": "Os lembretes permitem-lhe notificar automaticamente os clientes de que existem propostas à espera de uma decisão.",
        "intercom": "Olá Ziggu! Estou interessado na funcionalidade Lembretes. Pode fornecer mais informações? Com os melhores cumprimentos, %{name}"
      },
      "financials": {
        "guidance": "Crie planos de pagamento diretamente a partir de propostas aprovadas e partilhe-os com os seus clientes através do portal do cliente.<br>Mantenha a sua comunicação financeira transparente e profissional, os clientes têm sempre uma visão clara do que é devido e quando.",
        "intercom": "Olá Ziggu! Estou interessado na funcionalidade Finanças para prestações em decisões. Pode fornecer mais informações? Com os melhores cumprimentos, %{name}"
      },
      "imInterested": "Estou interessado!",
      "intercom": "Olá Ziggu! Estou interessado em saber mais sobre {upsell}. Podes fornecer mais informações? Com os melhores cumprimentos, %{name}",
      "interestedToBeListed": "Interessado em fazer parte da lista aqui",
      "lookingfor": "O que é que procura? Por exemplo, imagens 3d, cozinha, telecomunicações",
      "not_included": "Interessado nesta funcionalidade?",
      "project_email_forwarding": {
        "cta": "Reencaminhar as mensagens de correio eletrónico para {project_name}",
        "description": "Permita que todos os membros da sua equipa reencaminhem mensagens de correio eletrónico diretamente para os seus projectos Ziggu.",
        "intercom": "Olá Ziggu! Estou interessado na funcionalidade de reencaminhamento de correio eletrónico do projeto. Pode fornecer mais informações? Com os melhores cumprimentos, %{name}",
        "marketplace": {
          "title": "Reencaminhamento de correio eletrónico de projectos",
          "title_sub": "Encaminhar e-mails diretamente para os seus projectos Ziggu."
        },
        "title": "Novo! Reencaminhamento de correio eletrónico em projectos",
        "youtube_id": "vLQtH9GzAXc"
      },
      "project_experience": {
        "contactme": "Sim, pode contactar-me para isso!",
        "cta": "Melhorar a imagem de marca do seu projeto?",
        "description": "URL de projeto e ecrã de início de sessão personalizados <br/> Ambiente de projeto dedicado quando se inicia sessão <br/> E-mails com a marca do projeto <br/> Facilita o trabalho com outros promotores imobiliários no mesmo projeto",
        "intercom": "Olá Ziggu! Estou interessado no módulo Experiência de Projeto. Podes dar-me mais informações? Com os melhores cumprimentos, %{name}",
        "marketplace": {
          "title": "Experiência em projectos",
          "title_sub": "Melhore a imagem de marca do seu projeto com um url e um ambiente de projeto personalizados"
        },
        "title": "Faça com que os seus clientes se sintam em casa com a nova Experiência de Projeto!",
        "youtube_id": "f26cNo2rwWE"
      },
      "project_templates": {
        "cta": "Import from a template?",
        "cta2": "Importar este modelo para os seus projectos? Clique aqui para desbloquear esta funcionalidade!",
        "description": "Create a project template to quickly create new projects with predefined settings",
        "intercom": "Hello Ziggu! I'm interested in the Project Templates feature. Can you provide some more information? Kind regards, %{name}",
        "marketplace": {
          "title": "Project templates",
          "title_sub": "Create a project template to quickly create new projects with predefined settings"
        },
        "title": "New! Project templates"
      },
      "proposal_choice_lists": {
        "guidance": "As listas de escolha permitem-lhe permitir que os clientes façam escolhas nas propostas.",
        "intercom": "Olá Ziggu! Estou interessado na funcionalidade Listas de seleção. Pode fornecer mais informações? Com os melhores cumprimentos, %{name}"
      },
      "signatures": {
        "cta_text": "Precisa de assinaturas para os seus documentos? Contacte-nos",
        "guidance": "As assinaturas permitem-lhe permitir que os clientes assinem digitalmente documentos importantes.",
        "intercom": "Olá Ziggu! Estou interessado na funcionalidade Assinaturas. Pode fornecer mais informações? Com os melhores cumprimentos, %{name}"
      }
    }
  }
}
